import { CALL_API, Schemas } from '../../common/middleware/api';

export const PAYMENTS_REQUEST = 'PAYMENTS_REQUEST';
export const PAYMENTS_SUCCESS = 'PAYMENTS_SUCCESS';
export const PAYMENTS_FAILURE = 'PAYMENTS_FAILURE';

export const PAYMENT_FETCH_REQUEST = 'PAYMENT_GET_REQUEST';
export const PAYMENT_FETCH_SUCCESS = 'PAYMENT_GET_SUCCESS';
export const PAYMENT_FETCH_FAILURE = 'PAYMENT_GET_FAILURE';

export const SET_SUBGRADE_REQUEST = 'SET_SUBGRADE_REQUEST';
export const SET_SUBGRADE_SUCCESS = 'SET_SUBGRADE_SUCCESS';
export const SET_SUBGRADE_FAILURE = 'SET_SUBGRADE_FAILURE';

export const SUBSCRIPTION_FETCH_REQUEST = 'SUBSCRIPTION_FETCH_REQUEST';
export const SUBSCRIPTION_FETCH_SUCCESS = 'SUBSCRIPTION_FETCH_SUCCESS';
export const SUBSCRIPTION_FETCH_FAILURE = 'SUBSCRIPTION_FETCH_FAILURE';

export const SUBSCRIPTION_CANCEL_REQUEST = 'SUBSCRIPTION_CANCEL_REQUEST';
export const SUBSCRIPTION_CANCEL_SUCCESS = 'SUBSCRIPTION_CANCEL_SUCCESS';
export const SUBSCRIPTION_CANCEL_FAILURE = 'SUBSCRIPTION_CANCEL_FAILURE';

export const PaymentTypes = {
	Lesson: 'lesson',
	IndividualConsultation: 'individualConsultation',
	Workshop: 'workshop'
}

export const loadPayments = (options) => ({
	[CALL_API]: {
		types: [PAYMENTS_REQUEST, PAYMENTS_SUCCESS, PAYMENTS_FAILURE],
		endpoint: 'api/payments',
		request: options,
		schema: Schemas.PAYMENT_ARRAY
	}
});

export const fetchPayment = (id, type) => ({
	[CALL_API]: {
		types: [PAYMENT_FETCH_REQUEST, PAYMENT_FETCH_SUCCESS, PAYMENT_FETCH_FAILURE],
		endpoint: `api/payments/${type}/${id}`,
		schema: Schemas.PAYMENT
	}
});


// the subscription on an annual payment, with what cancelling it now would mean
export const fetchSubscription = (paymentId, onSuccess, onError) => ({
	[CALL_API]: {
		types: [SUBSCRIPTION_FETCH_REQUEST, SUBSCRIPTION_FETCH_SUCCESS, SUBSCRIPTION_FETCH_FAILURE],
		endpoint: `api/subscriptions/${paymentId}`,
		onSuccess,
		onError
	}
});

export const cancelSubscription = (paymentId, onSuccess, onError) => ({
	[CALL_API]: {
		types: [SUBSCRIPTION_CANCEL_REQUEST, SUBSCRIPTION_CANCEL_SUCCESS, SUBSCRIPTION_CANCEL_FAILURE],
		endpoint: `api/subscriptions/${paymentId}/cancellation`,
		method: 'POST',
		onSuccess,
		onError
	}
});

export const setPaymentSubGrade = (paymentId, gradeId, onSuccess) => ({
	[CALL_API]: {
		types: [SET_SUBGRADE_REQUEST, SET_SUBGRADE_SUCCESS, SET_SUBGRADE_FAILURE],
		endpoint: `api/payments/${paymentId}/${gradeId}`,
		method: 'PUT',
		onSuccess: onSuccess
	}
});